module.exports = __webpack_public_path__ + "static/media/SF-15-A.eff3237c.mp3";